export default "__VITE_ASSET__BAulOxzs__"